import React from 'react'
import { Layout, Menu } from 'antd'
import { useNavigate, useLocation } from 'react-router-dom'
import {
  DashboardOutlined,
  FileTextOutlined,
  BarChartOutlined,
  RobotOutlined,
  HomeOutlined,
  ApiOutlined,
  AuditOutlined,
  ScanOutlined,
} from '@ant-design/icons'

const { Sider } = Layout

interface SidebarProps {
  collapsed: boolean
  isMobile: boolean
  onClose?: () => void
}

const Sidebar: React.FC<SidebarProps> = ({ collapsed, isMobile, onClose }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const expandedWidth = isMobile ? 272 : 250

  const handleMenuClick = ({ key }: { key: string }) => {
    navigate(key)
    // Close sidebar in mobile after navigation
    if (isMobile && onClose) {
      onClose()
    }
  }

  const menuItems = [
    {
      key: '/dashboard',
      icon: <DashboardOutlined />,
      label: 'Dashboard',
    },
    {
      key: '/requests',
      icon: <FileTextOutlined />,
      label: 'Solicitudes',
    },
    {
      key: '/review',
      icon: <AuditOutlined />,
      label: 'Revisión Manual',
    },
    {
      key: '/analytics',
      icon: <BarChartOutlined />,
      label: 'Análisis',
    },
    {
      key: '/model',
      icon: <RobotOutlined />,
      label: 'Modelo IA',
    },
    {
      key: '/ocr',
      icon: <ScanOutlined />,
      label: 'OCR Documentos',
    },
    {
      key: '/api-operations',
      icon: <ApiOutlined />,
      label: 'Operaciones API',
    },
  ]

  return (
    <>
      {/* Mobile backdrop */}
      {isMobile && !collapsed && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.45)',
            zIndex: 1040,
            transition: 'opacity 0.3s ease',
          }}
          onClick={onClose}
        />
      )}
      
      <Sider
        width={expandedWidth}
        collapsed={collapsed}
        collapsedWidth={isMobile ? 0 : 80}
        style={{
          background: '#001529',
          position: 'fixed',
          height: '100vh',
          left: 0,
          top: 0,
          bottom: 0,
          zIndex: 1050,
          overflow: 'hidden',
          transition: 'transform 0.3s ease, width 0.3s ease',
          transform: collapsed && isMobile ? 'translateX(-100%)' : 'translateX(0)',
          boxShadow: collapsed ? 'none' : '2px 0 8px rgba(0,0,0,0.15)',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div
          style={{
            minHeight: 64,
            margin: collapsed && !isMobile ? 8 : 12,
            background: 'rgba(255, 255, 255, 0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: collapsed && !isMobile ? 'center' : 'flex-start',
            borderRadius: 8,
            padding: collapsed && !isMobile ? '0' : '0 12px',
            overflow: 'hidden',
            flexShrink: 0,
          }}
        >
          <HomeOutlined 
            style={{ 
              color: '#1890ff', 
              fontSize: collapsed && !isMobile ? '20px' : '24px',
              marginRight: collapsed && !isMobile ? 0 : 8,
              transition: 'all 0.3s ease'
            }} 
          />
          {!collapsed && (
            <span 
              style={{ 
                color: 'white', 
                fontSize: '16px', 
                fontWeight: 'bold',
                whiteSpace: 'nowrap',
                overflow: 'hidden'
              }}
            >
              Kredit Plus
            </span>
          )}
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[location.pathname]}
          items={menuItems}
          onClick={handleMenuClick}
          style={{ flex: 1, minHeight: 0, overflowY: 'auto', paddingBottom: 12 }}
        />
      </Sider>
    </>
  )
}

export default Sidebar